import {PageStandard} from "../utils/PageStandard";
import React, {useEffect, useState} from "react";
import {CategoriaModel, ServizioModel,} from "../utils/Model";
import {getCategories, getServices} from "../utils/ViewModel";
import {CircleMarker, MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import L from "leaflet";

export function Mappa() {

    const [servizi, setServizi] = useState<ServizioModel[]>([]);
    const [categorie, setCategorie] = useState<CategoriaModel[]>([]);

    useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        getCategories().then((data) => {
            setCategorie(data);
        });
        getServices().then((data) => {
            setServizi(data);
        });
    }

    const emojiStyle = {
        fontSize: "20px",
        textAlign: "center" as const,
        textShadow: "0 0 3px rgba(0,0,0,0.3)", // ombra leggera nera
        lineHeight: "20px",
        userSelect: "none",
    }

    function createEmojiIcon(emoji: string) {
        return L.divIcon({
            className: "custom-emoji-icon", // puoi usarla nel CSS se vuoi
            html: `<div style="
                  font-size: 30px;
                  text-align: center;
                  text-shadow: 0 0 10px rgba(0,0,0,0.25);
                  line-height: 30px;
                  user-select:none;
                ">${emoji}</div>`,
            iconSize: [30, 30],
            iconAnchor: [15, 15], // centro icona
            popupAnchor: [0, -15],
        })
    }
    return (
        <PageStandard
            title="Mappa"
            sidebarVisible={true}
        >
            <div style={{height: "80vh"}}>
                <MapContainer
                    center={[45.07049, 7.68682]}
                    zoom={16}
                    scrollWheelZoom={true}
                    className="map-container-leaflet"
                    style={{height: "100%", width: "100%"}}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {servizi.map((s) => {
                        const categoria = categorie.find((c) => c.id === s.categoryId)
                        return (
                            <React.Fragment key={s.id}>
                                <CircleMarker
                                    center={[s.coordinates.lat, s.coordinates.lng]}
                                    radius={30}
                                    pathOptions={{ color: "transparent", fillColor: "white", fillOpacity: 1 }}
                                >
                                    <Popup>
                                        <div style={{minWidth: 150}}>
                                            <strong>{s.title}</strong>
                                            <br />
                                            Lat: {s.coordinates.lat.toFixed(5)}, Lng: {s.coordinates.lng.toFixed(5)}
                                            <br />
                                            {categoria?.icon} {categoria?.title}
                                        </div>
                                    </Popup>
                                </CircleMarker>
                                {/* Marker con icona emoji al centro */}
                                {categoria?.icon && (
                                    <Marker
                                        position={[s.coordinates.lat, s.coordinates.lng]}
                                        icon={createEmojiIcon(categoria.icon)}
                                        interactive={false} // per non interferire con clic popup
                                    />
                                )}
                            </React.Fragment>
                        )
                    })}
                </MapContainer>
            </div>
        </PageStandard>
    );
}